import type { EventDTO, LogDTO } from "../../api/contract";
import { apiGet, buildQuery } from "./http";

export function getEvents(limit?: number): Promise<EventDTO[]> {
  return apiGet<EventDTO[]>(`/api/events${buildQuery({ limit })}`);
}

export interface LogsFilter {
  jobId?: string;
  limit?: number;
}

export function getLogs(filter: LogsFilter = {}): Promise<LogDTO[]> {
  return apiGet<LogDTO[]>(`/api/logs${buildQuery(filter as Record<string, unknown>)}`);
}
